export default "__VITE_ASSET__c20881c1__"